// extracted by mini-css-extract-plugin
module.exports = {"theme":"#2e8ec9"};